<template>
    <modal title="Ergebnis">
        <ion-grid>
            <ion-row>
                <ion-col size="12">
                    <h3>
                        Zinsersparnis & Laufzeitverkürzung inkl.
                        Simulationswerte
                    </h3>
                </ion-col>
                <ion-col size="12" class="ion-margin-bottom">
                    <ion-item>
                        <ion-label position="floating">Zinsersparnis</ion-label>
                        <ion-input
                            readonly
                            :value="
                                $options.filters.currency(
                                    result.ersparnisRueckzahlung
                                )
                            "
                        ></ion-input>
                    </ion-item>
                </ion-col>
                <ion-col size="12" class="ion-margin-bottom">
                    <ion-item>
                        <ion-label position="floating"
                            >Laufzeitverkürzung</ion-label
                        >
                        <ion-input
                            readonly
                            :value="result.laufzeitVerkuerzung + ' Monate'"
                        ></ion-input>
                    </ion-item>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col class="ion-margin-bottom">
                    <ion-item>
                        <ion-label position="floating"
                            >Einzahlungsbetrag</ion-label
                        >
                        <ion-input
                            readonly
                            :value="$options.filters.currency(betrag)"
                        ></ion-input>
                    </ion-item>

                    <div class="u-size-small">
                        <b>{{
                            result.summeEinzahlungenNeuProzent | percent
                        }}</b>
                        der Darlehenssumme
                    </div>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col class="ion-margin-bottom">
                    <ion-item>
                        <ion-label position="floating"
                            >Einzahlungen inkl. Simulationswerte</ion-label
                        >
                        <ion-input
                            readonly
                            :value="
                                $options.filters.currency(
                                    result.summeEinzahlungenNeu
                                )
                            "
                        ></ion-input>
                    </ion-item>

                    <div class="u-size-small">
                        <b>{{
                            result.summeSpontanEinzahlungenNeuProzent | percent
                        }}</b>
                        des maximal ursprünglichen
                        Spontanrückzahlungs&shy;betrags
                    </div>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col class="ion-margin-bottom">
                    <ion-item>
                        <ion-label position="floating" class="ion-text-wrap"
                            >Bisherige Spontanrückzahlungen inkl.
                            Simulationswerte</ion-label
                        >
                        <ion-input
                            readonly
                            :value="
                                $options.filters.currency(
                                    result.summeSpontanEinzahlungenNeu
                                )
                            "
                        ></ion-input>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>
        <template v-slot:footer>
            <ion-button
                expand="block"
                @click="$parent.$emit('betrag-einzahlen')"
                v-show="isPaymentPossible"
                >Einzahlen</ion-button
            >
        </template>
    </modal>
</template>

<script>
import Modal from "./Modal";

export default {
    props: ["betrag", "result", "isPaymentPossible"],
    components: {
        Modal,
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
ion-input {
    font-weight: bold;
}
ion-label {
    font-size: large !important;
}
</style>
